/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub';
import { AsideMenuItem } from './AsideMenuItem';
import { UserTypeId } from '../../../helpers/constants';
import { RootState } from '../../../states/reducers';
import { useSelector } from 'react-redux';

type Menu = {
  route: string;
  title: string;
  fontIcon: string;
  roles?: number[];
};

const menus: Menu[] = [
  {
    route: '/dashboard',
    title: 'Dashboard',
    fontIcon: 'bi-app-indicator',
  },
  {
    route: '/loans',
    title: 'Loans',
    fontIcon: 'bi-briefcase',
    roles: [UserTypeId.BORROWER, UserTypeId.INVESTOR],
  },
  {
    route: '/investments',
    title: 'Investments',
    fontIcon: 'bi-bar-chart-steps',
    roles: [UserTypeId.INVESTOR],
  },
  // {
  //   route: '/co-investments',
  //   title: 'Co-Investments',
  //   fontIcon: 'bi-grid-1x2',
  //   roles: [UserTypeId.INVESTOR],
  // },
  // {
  //   route: '/service-providers',
  //   title: 'Service Providers',
  //   fontIcon: 'bi-people',
  //   roles: [UserTypeId.INVESTOR],
  // },
  // {
  //   route: '/jobs',
  //   title: 'Jobs',
  //   fontIcon: 'bi-clipboard',
  //   roles: [UserTypeId.INVESTOR, UserTypeId.SERVICE_PROVIDER],
  // },
  {
    route: '/bids',
    title: 'Bids',
    fontIcon: 'bi-tags',
    roles: [UserTypeId.SERVICE_PROVIDER],
  },
  {
    route: '/messages',
    title: 'Messages',
    fontIcon: 'bi-envelope',
  },
  {
    route: '/transactions',
    title: 'Transactions',
    fontIcon: 'bi-credit-card-2-front',
  },
  {
    route: '/settings',
    title: 'Account Settings',
    fontIcon: 'bi-gear',
  },
];

export function AsideMenuMain() {
  const { auth } = useSelector((state: RootState) => state);
  const userTypeId = auth.authUser!.user.user_type_id;
  return (
    <>
      {menus.map((menu) => (!menu.roles || menu.roles.includes(userTypeId)) && <AsideMenuItem key={menu.title} to={menu.route} title={menu.title} fontIcon={menu.fontIcon} />)}

      {/* <AsideMenuItemWithSub to='/crafted/accounts' title='Accounts' icon='/media/icons/duotune/communication/com006.svg' fontIcon='bi-person'>
        <AsideMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <AsideMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </AsideMenuItemWithSub> */}
    </>
  );
}
